import React from 'react';
import { Typography } from 'antd';
import { BiError } from 'react-icons/bi';
import '../FileManagerModals.scss';

const { Text } = Typography;

type ErrorMessageProps = {
  error?: string;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error }) =>
  error ? (
    <div className="error">
      <BiError color="red" />
      <Text className="error-text">{error}</Text>
    </div>
  ) : null;
